<template>
	<div class="layout-page-v2">
		<div class="header">
			<div class="title">
				<svgicon v-if="icon" :name="icon" :fill="false" class="icon"/>
				<h1 v-if="h1">{{ h1 }}</h1>
				<h2 v-if="h2">{{ h2 }}</h2>
			</div>
			<slot name="btn-group"></slot>
		</div>
		<div class="body">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	inject: ['$validator'],
	props: [
		'icon',
		'h1',
		'h2'
	]
}
</script>



// WEBPACK FOOTER //
// src/components/layouts/LayoutPageV2.vue